// @ts-nocheck
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 2,
    },
});
